import { styled } from "@mui/material";

export const StyledContainer = styled("div")(() => ({
  position: "absolute",
  backgroundColor: "white",
  padding: "4px 8px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  pointerEvents: "none",
}));
